import React from "react";
import update from 'immutability-helper';

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { AutoComplete } from 'primereact/autocomplete';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { Message } from 'primereact/message';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels, ControlTypes } from './RiskLevels'

import UserContext from '../context/UserContext';

import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ControlDialog extends React.Component {

	static contextType = UserContext;

	state = {
		modified: false,
		isLoadingData: false,
		control: { 
			controlID: 0,
			riskID: 0,
			name: 'New Control',
			description: '',
			measures:'',
			controlType: 1,

			workTask: 0,
			taskIsWN: true,
			taskDescription: '',
			taskResponsible: 0,
			dependencyType: 2,
			supportingSystem: '',
			taskTrigger: '',
			supportingEvidence: '',


			probabilityAfter: 1,
			consequenceAfter: 1,

			testInstruction:'',
			testFrequency: '',
			tester: 0,	

		},
		taskDescriptionWN: '',
		taskResponsibleWN: '', 

		workFlowList: [{ id: 0, name: "-", items:[]},],
		workTaskList:[],
		risk: {
			riskID: 0, 
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
			consequenceAfter: 1,
			probabilityAfter: 1
		},
		roleList: [],
		dependencyList: [{ id: 1, label: "Automated" }, { id: 2, label: "IT dependent"}, {id:3,label:"Manual"}],
	};


	componentDidMount() {
		if (this.props.risk !== null) {
			this.setState({ risk: this.props.risk });
		}
		this.fetchRoles();
		this.fetchControlTasks();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.risk !== this.props.risk && this.props.risk !== null) {
			this.setState({ risk: this.props.risk });
		}
		if (prevProps.controlID !== this.props.controlID && this.props.controlID !== null) {
			if (this.props.controlID !== 0) {
				this.fetchControl(this.props.controlID);
			} else {
				this.resetForm();			
			}
		}
		if (prevProps.visible !== this.props.visible && !this.props.visible) {
			this.resetForm()
		}
	}

	resetForm() {
		
		var tester = 0;
		var taskResponsible = 0;
		const RiskID = this.state.risk.riskID

		if (this.state.roleList && this.state.roleList.length > 0) {
			const user = this.context.user;
			if (user.roleList.length === 0) {
				tester = this.state.roleList[0].roleID;
				taskResponsible = this.state.roleList[0].roleID;
			} else {
				const ownerSuggestion = this.state.roleList.find(role => { return user.roleList.find(userRole => userRole.roleID === role.roleID) });
				tester = ownerSuggestion.roleID;
				taskResponsible = ownerSuggestion.roleID;
			}
		}

		this.setState({		
			control: {
				controlID: 0,
				riskID: RiskID,
				name: 'New Control',
				description: '',
				measures:'',
				controlType: 1,
				workTask: 0,
				taskDescription: '',
				taskResponsible: taskResponsible,
				probabilityAfter: 1,
				consequenceAfter: 1,
				frequency: '',
				tester: tester,
				taskIsWN: true,
				dependencyType: 2,
				supportingSystem: '',
				taskTrigger: '',
				suportingEvidence: '',
			}
		});

		this.setState({ modified: false });
		this.setState({ taskDescriptionWN: '' });
		this.setState({ taskResponsibleWN: '' });
		this.setState({ isLoadingData: false });	

	}

	fetchControl(controlID) {
		this.setState({ isLoadingData: true });
		fetch(`api/Mitigation/GetControl/` + controlID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				if (data.workTask !== 0) {
					const workTask = this.state.workTaskList.find(element => element.id === data.workTask);

					this.setState({ taskDescriptionWN: workTask.description });
					this.setState({ taskResponsibleWN: workTask.responsible });
				}

				if (data.taskIsWN) {
					if (this.state.roleList && this.state.roleList.length > 0) {
						const user = this.context.user;

						const ownerSuggestion = this.state.roleList.find(role => { return user.roleList.find(userRole => userRole.roleID === role.roleID) });
						data.taskResponsible = ownerSuggestion.roleID;
						data.dependencyType = 1;
					} else {
						data.taskResponsible = 1;
						data.dependencyType = 1;
					}
				}

				this.setState({ control: data });	
				this.setState({ hasChanged: false });
				this.setState({ isLoadingData: false });				
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchControlTasks() {
		this.setState({ isLoadingData: true });
		fetch(`api/Template/GetControlTasks`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				data.flowList.forEach((flow) => {
					flow.items = data.taskList.filter((task) =>  task.flowTemplateID === flow.id );
				});

				this.setState({ workFlowList: data.flowList });
				this.setState({ workTaskList: data.taskList });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchAddControl() {
		this.setState({ isLoadingData: true });		

		var control = { ...this.state.control };
		control.riskID = this.state.risk.riskID;

		fetch(`api/Mitigation/AddControl`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(control) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				if (this.props.onClose != null) {
					this.props.onClose(true);
				}
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}


	fetchChangeControl() {
		this.setState({ isLoadingData: true });
		
		fetch(`api/Mitigation/ChangeControl`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.control) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				if (this.props.onClose != null) {
					this.props.onClose(true);
				}
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	fetchRoles() {
		this.setState({ isLoadingData: true });
		fetch('api/UserRoles/GetListofRoles', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ roleList: data });
				this.setState({ isLoadingData: false });
				this.preSetOwners(data);
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
				//Gör något om fel
			})
	}

	preSetOwners(roles) {
		if (roles.length > 0 && this.state.risk.riskID === 0) {
			const user = this.context.user;
			if (user.roleList.length === 0) {
				const control = update(this.state.control, { "tester": { $set: roles[0].roleID }, "taskResponsible": { $set: roles[0].roleID } });
				
				this.setState({ control: control });
			} else {
				const ownerSuggestion = roles.find(role => { return user.roleList.find(userRole => userRole.roleID === role.roleID) });
				const control = update(this.state.control, { "tester": { $set: ownerSuggestion.roleID }, "taskResponsible": { $set: ownerSuggestion.roleID } });
				
				this.setState({ control: control });
			}
		}
	}

	handleTaskTypeChanged(e) {
		const control = update(this.state.control, { "taskIsWN": { $set: !this.state.control.taskIsWN } });
		this.setState({ control: control });
	}

	handleWorkTaskSelected(e) {
		if (e.value !== this.state.workTask) {			
			this.onChange('workTask', e.value);

			const workTask = this.state.workTaskList.find(element => element.id === e.value)

			this.setState({ taskDescriptionWN: workTask.description });
			this.setState({ taskResponsibleWN: workTask.responsible });
		}
	}

	cancelDialog() {
		if (this.props.onClose != null) {
			this.setState({ hasChanged: false });
			//this.resetForm();
			this.props.onClose(false);
		}
	}

	closeDialog() {	
		//check that it is properly filled out
		if (this.state.control.controlID === 0) {
			this.fetchAddControl();
			this.setState({ hasChanged: false });
		} else {
			this.fetchChangeControl();
			this.setState({ hasChanged: false });
		}
		//this.resetForm();
	}

	onChange(field, value) {
		const control = update(this.state.control, { [field]: { $set: value } });
		this.setState({ control: control });
		this.setState({ modified: true });
	}

	probabilityOptionTemplate (option)  {
		if (option.id > this.state.risk.probability) {
			return (
				<div className="flex align-items-center">
					<div style={{ color: "lightgrey" }}>{option.text}</div>
				</div>
			);
		}
		return (
			<div className="flex align-items-center">
				<div>{option.text}</div>
			</div>
		);
	}

	consequenceOptionTemplate (option) {
		if (option.id > this.state.risk.consequence) {
			return (
				<div className="flex align-items-center">
					<div style={{ color: "lightgrey" }}>{option.text}</div>
				</div>
			);
		}
		return (
			<div className="flex align-items-center">
				<div>{option.text}</div>
			</div>
		);
	}

	groupedItemTemplate (option) {
		return (
			<div className="flex align-items-center">
				<FontAwesomeIcon icon={faShareNodes} /> &nbsp;
				<div>{option.name}</div>
			</div>
		);
	}

	render() {
		const riskBgColor = RiskLevels[this.state.control.consequenceAfter - 1][this.state.control.probabilityAfter - 1].bgColor;
		const riskColor = RiskLevels[this.state.control.consequenceAfter - 1][this.state.control.probabilityAfter - 1].color;

		const footerContent = (
			<div>
				<Button label="Cancel" icon="pi pi-times" onClick={() => this.cancelDialog()} className="p-button-secondary" disabled={this.state.isLoadingData} />
				<Button label="Save and close" icon="pi pi-check" onClick={() => this.closeDialog()} disabled={!this.state.modified || this.state.isLoadingData} />
			</div>
		);

		return (
			<Dialog header="Control" visible={this.props.visible} style={{ width: '75vw', height: '75vh', overflow: 'hidden' }} maximizable footer={footerContent}
				modal contentStyle={{ height: '300px' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis:  'auto' } }>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom:'1.5rem' }}>
						<Card.Header>
							<b>Details</b> 
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">
								<div className="p-field">
									<label className="p-field-label">Name</label>
									<InputText value={this.state.control.name} maxLength="50" onChange={(e) => { this.onChange( 'name', e.target.value ); }} className="w-full md:w-20rem" />
								</div>
								
								<div className="p-field">
									<label className="p-field-label">Control type</label>
									<Dropdown value={this.state.control.controlType} onChange={(e) => { this.onChange('controlType', e.target.value); }} options={ControlTypes} optionValue="id" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
								</div>
								
								<div className="p-field">
									<label className="p-field-label">Control description</label>
									<InputTextarea className="w-full md:w-20rem" value={this.state.control.description} onChange={(e) => { this.onChange('description', e.target.value); }} rows={3} cols={30} placeholder="Short description of how this reduces the risk" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Control measures</label>
									<InputTextarea className="w-full md:w-20rem" value={this.state.control.measures} onChange={(e) => { this.onChange('measures', e.target.value); }} rows={3} cols={30} placeholder="Short description of what measures to take if control fails" />
								</div>

							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }} >
						<Card.Header>
							<b>Task</b>
							<div style={{ float: 'right' }}>
								<Form.Check
									type="switch"
									label="WorkNodes task"
									reverse
									checked={this.state.control.taskIsWN}
									onChange={(e) => { this.handleTaskTypeChanged(e); }}
									/>
							</div>
						</Card.Header>
						<Card.Body>
							{this.state.control.taskIsWN ?

								<div className="p-fluid md:w-20rem" style={{ minWidth: '20rem' }}>
									 
									<div className="p-field">
										<label className="p-field-label">WorkTask</label>
										<Dropdown
											value={this.state.control.workTask}
											onChange={(e) => { this.handleWorkTaskSelected(e); }}
											options={this.state.workFlowList}
											optionValue="id"
											optionLabel="name"
											placeholder="Select at WorkTask"
											className="w-full md:w-20rem"
											optionGroupLabel="name"
											optionGroupChildren="items"
											optionGroupTemplate={this.groupedItemTemplate.bind(this)}
										/>
									</div>
									
									<div className="p-field">
										<label className="p-field-label">WorkTask description</label>
										<InputTextarea variant="filled" value={this.state.taskDescriptionWN} rows={5} cols={30} readOnly className="md:w-20rem" />
									</div>

									<div className="p-field">
										<label className="p-field-label">Responsible</label>
										<InputText value={this.state.taskResponsibleWN} maxLength="50" readOnly className="md:w-20rem" />
									</div>
								</div>
								: 
								<div className="p-fluid md:w-20rem" style={{ minWidth: '20rem' }}>
									<div className="p-field">
										<label className="p-field-label">WorkTask description</label>
										<InputTextarea value={this.state.control.taskDescription} onChange={(e) => { this.onChange('taskDescription', e.target.value); }} rows={3} cols={30} className="md:w-20rem" placeholder="Short description of how the control is performed" />
									</div>
									
									<div className="p-field">
										<label className="p-field-label">Responsible</label>
										<Dropdown value={this.state.control.taskResponsible} onChange={(e) => { this.onChange('taskResponsible', e.target.value); }} options={this.state.roleList} optionValue="roleID" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
									</div>
									
									<div className="p-field">
										<label className="p-field-label">Frequency/Trigger</label>
									<InputText value={this.state.control.taskTrigger} maxLength="50" onChange={(e) => { this.onChange('taskTrigger', e.target.value); }} className="w-full md:w-20rem" placeholder="When, how or what triggers the control" />
									</div>

									<div className="p-field">
										<label className="p-field-label">Supporting evidence</label>
										<InputTextarea value={this.state.control.supportingEvidence} onChange={(e) => { this.onChange('supportingEvidence', e.target.value); }} rows={3} cols={30} className="md:w-20rem" placeholder="Documents, system log etc" />
									</div>

									<div className="p-field">
										<label className="p-field-label">IT dependence</label>
										<Dropdown value={this.state.control.dependencyType} onChange={(e) => { this.onChange('dependencyType', e.target.value); }} options={this.state.dependencyList} optionValue="id" optionLabel="label" placeholder=" " className="w-full md:w-20rem" />
									</div>
									{this.state.control.dependencyType !== 3 ?
										<div className="p-field">
											<label className="p-field-label">Supporting system</label>
											<InputText value={this.state.control.supportingSystem} maxLength="50" onChange={(e) => { this.onChange('supportingSystem', e.target.value); }} className="w-full md:w-20rem" placeholder="Systems used for this task" />
										</div>
										//<div className="p-field">
										//	<label className="p-field-label">Supporting system</label>
										//	<AutoComplete value={this.state.control.supportingSystem} suggestions={null} completeMethod={ null } dropdown className="w-full md:w-20rem" />
										//</div>
									:null}
								</div>
							}
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }} >
						<Card.Header>
							<b>Risk after control</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem" style={{ minWidth: '20rem' }}>
								{this.state.control.consequenceAfter > this.state.risk.consequence ?
									<Message severity="warn" text="Higher consequence after control" />
									: this.state.control.probabilityAfter > this.state.risk.probability ?
										<Message severity="warn" text="Higher probability after control" />
										: this.state.control.consequenceAfter === this.state.risk.consequence && this.state.control.probabilityAfter === this.state.risk.probability ?
											<Message severity="warn" text="No change in risk after control" />
											: null
								}
								
								<div className="p-field">
									<label className="p-field-label">Probability</label>
									
									<Dropdown
										value={this.state.control.probabilityAfter}
										onChange={(e) => { this.onChange('probabilityAfter', e.target.value); }}
										options={ProbabilityLevels}
										optionLabel="text"
										optionValue="id"
										placeholder=" "
										className="w-full md:w-20rem"
										itemTemplate={this.probabilityOptionTemplate.bind(this)}
									/>
								</div>
									
								<div className="p-field">
									<label className="p-field-label">Consequence</label>
									
									<Dropdown
										value={this.state.control.consequenceAfter}
										onChange={(e) => { this.onChange('consequenceAfter', e.target.value); }}
										options={ConsequenceLevels}
										optionLabel="text"
										optionValue="id"
										placeholder=" "
										className="w-full md:w-20rem"
										itemTemplate={this.consequenceOptionTemplate.bind(this)}
									/>
									
								</div>

								<div className="p-field">
									<label className="p-field-label">Risk</label>
									<InputText value={RiskLevels[this.state.control.consequenceAfter - 1][this.state.control.probabilityAfter - 1].label} style={{ backgroundColor: riskBgColor, color: riskColor }} className="w-full md:w-20rem" />
								</div>
							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }} >
						<Card.Header>
							<b>Testing</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem" style={{ minWidth: '20rem' }}>

								<div className="p-field">
									<label className="p-field-label">Instruction</label>
									<InputTextarea className="w-full md:w-20rem" value={this.state.control.testInstruction} onChange={(e) => { this.onChange('testInstruction', e.target.value); }} rows={3} cols={30} placeholder="Short description of how to perform the test" />
								</div>

								<div className="p-field">
									<label className="p-field-label">Frequency</label>
									<InputText value={this.state.control.testFrequency} maxLength="50" onChange={(e) => { this.onChange('testFrequency', e.target.value);  }} className="w-full md:w-20rem" />
								</div>
								
								<div className="p-field">
									<label className="p-field-label">Responsible</label>
									<Dropdown value={this.state.control.tester} onChange={(e) => { this.onChange('tester', e.target.value); }} options={this.state.roleList} optionValue="roleID" optionLabel="name" placeholder=" " className="w-full md:w-20rem" />
								</div>
								
							</div>
						</Card.Body>
					</Card>

				</div>					
			</Dialog>
				);
	}
}
export default (ControlDialog);
